import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { useEmployeeOfferId, useEmployeeOfferUrl } from 'domain/people/employee/offers/employeeOfferRouting';
import useEmployeeOfferService from 'domain/people/employee/offers/shared/employeeOfferService';
import { EmployeeOfferFormData } from 'domain/people/employee/offers/shared/offerTypes';
import type { OfferCompensationDetails } from 'domain/shared/offerCompensation/model';

const getCopiedOfferData = (offer: EmployeeOfferFormData): EmployeeOfferFormData => ({
  positionId: offer.positionId,
  technologyId: offer.technologyId,
  competencyLevel: offer.competencyLevel,
  contractDuration: offer.contractDuration,
  additionalInformation: offer.additionalInformation,
  attachmentIds: offer.attachmentIds,
  offerCompensations: (offer.offerCompensations || []).map(
    ({ id, sensitiveDataId, createdAt, updatedAt, ...compensation }: OfferCompensationDetails) => ({
      ...compensation,
      isAccepted: false,
    }),
  ),
});

const CopyEmployeeOfferButton = () => {
  const offerId = useEmployeeOfferId();
  const { getCreateUrl } = useEmployeeOfferUrl();
  const { getById } = useEmployeeOfferService();
  const navigate = useNavigate();

  const handleCopy = async () => {
    const offer = (await getById(offerId)) as Nullable<EmployeeOfferFormData>;

    if (offer) {
      navigate(getCreateUrl(), { state: { initialOffer: getCopiedOfferData(offer) } });
    }
  };

  return (
    <Button color="primary" onClick={handleCopy} type="button" size="small">
      Copy
    </Button>
  );
};

export default CopyEmployeeOfferButton;
